import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PanelCard from '../../performance-operations/components/PanelCard';
import { Sub } from '../../performance-operations/styles';
import { formatNumber } from '../../performance-operations/config';
import { StatList, StatRow } from '../styles';
import { ATTENTION_HIGH_PERF_NO_POTENTIAL, MISSING_REASONS } from '../config';

// Analiz E09 — "eksik eksenli kişi sayısı ayrıca görünür": matrise girmeyen kişiler neden kırılımıyla (matris n + eksik = beklenen n).
// Satır tıklaması listeyi o nedene süzer (yalnız potansiyel erişimi olan — neden kişi bazında potansiyel bilgisidir).
export function MissingAxisPanel({ panel, selection, onSelect }) {
  const { t, i18n } = useTranslation();
  const data = panel.data;
  const visible = data?.potentialVisible !== false;
  const missing = data?.missing || {};
  return (
    <PanelCard
      panelKey="missing" title={t('talent.nineBoxTransitions.panel.missing')} span={4}
      loading={panel.loading} error={panel.error} onRetry={panel.retry}
    >
      <Sub data-meta="missing-total">{t('talent.nineBoxTransitions.missingTotal', { n: missing.total ?? 0, expected: data?.expectedN ?? 0 })}</Sub>
      <StatList>
        {MISSING_REASONS.map((reason) => (
          <StatRow
            key={reason} type="button" data-missing={reason} disabled={!visible || !missing[reason]}
            $selected={selection?.type === 'missing' && selection.reason === reason}
            onClick={() => onSelect({ type: 'missing', reason })}
          >
            <span>{t(`talent.nineBoxTransitions.missing.${reason}`)}</span>
            <strong>{formatNumber(missing[reason] ?? 0, i18n.language, 0)}</strong>
          </StatRow>
        ))}
      </StatList>
    </PanelCard>
  );
}

// Analiz E09 AI alanı — kural tabanlı dikkat bulguları (puan/potansiyel tahmini üretmez): performansı yüksek olup potansiyeli
// değerlendirilmeyenler (AI05) ve hazır onaylı yedeği olmayan kritik pozisyonlar (AI07). Öneri: değerlendirme görevi ya da yedek
// planını inceleme.
export function AttentionPanel({ panel, selection, onSelect, canSeeSuccession }) {
  const { t, i18n } = useTranslation();
  const data = panel.data;
  const visible = data?.potentialVisible !== false;
  return (
    <PanelCard
      panelKey="attention" title={t('talent.nineBoxTransitions.panel.attention')} span={4}
      loading={panel.loading} error={panel.error} onRetry={panel.retry}
    >
      <StatList>
        {visible ? (
          <StatRow
            type="button" data-attention={ATTENTION_HIGH_PERF_NO_POTENTIAL} disabled={!data?.highPerformanceWithoutPotential}
            $selected={selection?.type === 'attention'}
            onClick={() => onSelect({ type: 'attention', attention: ATTENTION_HIGH_PERF_NO_POTENTIAL })}
          >
            <span>{t('talent.nineBoxTransitions.attention.highPerfNoPotential')}</span>
            <strong>{formatNumber(data?.highPerformanceWithoutPotential ?? 0, i18n.language, 0)}</strong>
          </StatRow>
        ) : null}
        {data?.successionActive ? (
          <div data-attention="succession">
            <Sub>{t('talent.nineBoxTransitions.attention.noReadySuccessor', { n: data.criticalPositionsWithoutReadySuccessor, total: data.criticalPositions })}</Sub>
            {canSeeSuccession && data.criticalPositionsWithoutReadySuccessor > 0
              ? <Link to="/talent/succession" data-link="succession">{t('talent.nineBoxTransitions.attention.reviewSuccession')}</Link>
              : null}
          </div>
        ) : <Sub>{t('talent.nineBoxTransitions.attention.noSuccession')}</Sub>}
      </StatList>
      <Sub>{t('talent.nineBoxTransitions.attention.disclaimer')}</Sub>
    </PanelCard>
  );
}
